import React from "react";
import styled from "styled-components";

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
            <p className="font13">
              Speak to an expert. Find out what Eryvez can do for you.
            </p>
          </HeaderInfo>
          <ContentWrapper>
            {/* Contact Information */}
            <ContactInfo>
              <h2 className="font20 extraBold">Eryvez Pvt Ltd</h2>
              <p className="font13">
                Email: <a href="mailto:info@eryvez.com" className="purpleColor">info@eryvez.com</a>
              </p>
              <p className="font13">
                Phone: <a href="tel:+94768839673" className="purpleColor">+94 768839673</a>
              </p>
            </ContactInfo>

            {/* Send Email Button */}
            <ButtonWrapper>
              <a
                href="mailto:info@eryvez.com?subject=Inquiry&body=Hello,%20I%20would%20like%20to%20discuss..."
                className="pointer animate radius8"
                style={{
                  padding: "15px 30px",
                  backgroundColor: "#7620ff",
                  color: "#fff",
                  borderRadius: "8px",
                  textDecoration: "none",
                  textAlign: "center",
                  display: "inline-block",
                }}
              >
                Send Email
              </a>
            </ButtonWrapper>
          </ContentWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px 0;
`;

const ContactInfo = styled.div`
  text-align: center;

  h2 {
    margin-bottom: 10px;
  }

  p {
    margin: 5px 0;
  }

  a {
    text-decoration: none;
    color: #7620ff;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ButtonWrapper = styled.div`
  text-align: center;
`;
